import popupImage from 'assets/images/promotions/subscription-free-product-offer-mobile@3x.jpg';

export const content = {
  title: 'Kickstart hair growth with free Custom Supplements',
  description: 'Subscribe today and get your first order free.',
  image: {
    src: popupImage,
    alt: 'Two jars of Root Source Herbal Supplements by Prose, labeled with the name Naomi, placed on a white surface. One jar is open, with a softgel and a capsule next to it. The jars have amber glass and black lids. Smooth stones are nearby, creating a clean and calming setting.',
  },
  badge: {
    label: 'Exclusive Trial Offer',
  },
  cta: {
    label: 'SUBSCRIBE TO SUPPLEMENTS',
  },
};
